import { CAlert, CButton } from "@coreui/react";
import { useGetUnscoredDatasetStats } from "./services/DatasetServices";

import PropTypes from "prop-types";
import React, { useState } from "react";
import { ScoreDatasetModal } from "./ScoreDataset";
import { useGetModelVersionByVersionId } from "../models/ModelService";

export const ScoringProgressBar = ({ unscoredDataStats }) => {
  const denominator =
    unscoredDataStats?.scoring +
    unscoredDataStats?.waiting +
    unscoredDataStats?.scored +
    unscoredDataStats?.saving +
    unscoredDataStats?.complete;

  return (
    <>
      {unscoredDataStats && denominator > 0 && (
        <>
          <progress
            max="1"
            value={
              denominator > 0 ? unscoredDataStats.complete / denominator : 0.0
            }
          ></progress>
          <br />
          Completed{" "}
          {unscoredDataStats.complete ? unscoredDataStats.complete : 0} of{" "}
          {denominator > 0 ? denominator : "?"}
        </>
      )}
    </>
  );
};

ScoringProgressBar.propTypes = {
  unscoredDataStats: PropTypes.shape({
    scoring: PropTypes.number,
    waiting: PropTypes.number,
    scored: PropTypes.number,
    saving: PropTypes.number,
    complete: PropTypes.number,
  }),
};

export const DatasetScoreWarning = (props) => {
  const [isScoreDatasetModalVisible, setScoreDatasetModalVisible] =
    useState(false);
  const { data: unscoredDataStats } = useGetUnscoredDatasetStats(
    props.datasetId,
    props.modelVersionId,
  );

  const { data: model } = useGetModelVersionByVersionId(props.modelVersionId);

  return (
    <>
      {unscoredDataStats &&
        (unscoredDataStats.unscored_count > 0 ||
          unscoredDataStats.old_scored_count > 0) && (
          <div>
            <CAlert color="warning" style={{ textAlign: "center" }}>
              {unscoredDataStats.unscored_count > 0 && (
                <>
                  <strong>{unscoredDataStats.unscored_count}</strong> records in
                  the dataset have not been scored.
                </>
              )}
              {unscoredDataStats.old_scored_count > 0 && (
                <>
                  <br />
                  <strong>{unscoredDataStats.old_scored_count}</strong> records
                  in the dataset have not been scored since they were updated.
                </>
              )}
              {props.additionalWarning && (
                <>
                  <br /> <br /> {props.additionalWarning}
                </>
              )}
            </CAlert>
            <div style={{ textAlign: "center" }}>
              <ScoringProgressBar
                datasetId={props.datasetId}
                modelVersionId={props.modelVersionId}
              />
            </div>
            <div style={{ textAlign: "center" }}>
              {props.canScore && (
                <div>
                  <CButton
                    color="warning"
                    onClick={() => setScoreDatasetModalVisible(true)}
                    disabled={!props.canScore}
                    data-attr="datasets:btn:score-now"
                  >
                    Score Now
                  </CButton>
                </div>
              )}
            </div>
            <div>
              {!props.canScore &&
                model?.versions &&
                model?.versions[props.modelVersionId] &&
                !model?.versions[props.modelVersionId]?.is_deployed && (
                  <div>
                    <CAlert
                      color="danger"
                      style={{ textAlign: "center", marginTop: "1em" }}
                    >
                      {props.modelName} must be deployed before scoring.
                    </CAlert>
                  </div>
                )}
            </div>
          </div>
        )}
      <ScoreDatasetModal
        datasetId={props.datasetId}
        modelVersionId={props.modelVersionId}
        isVisibile={isScoreDatasetModalVisible}
        onClose={() => {
          setScoreDatasetModalVisible(false);
        }}
      />
    </>
  );
};

DatasetScoreWarning.propTypes = {
  datasetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  modelVersionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  additionalWarning: PropTypes.string,
  canScore: PropTypes.bool,
  modelName: PropTypes.string,
};

DatasetScoreWarning.defaultProps = {
  additionalWarning: null,
};
